module.exports = __webpack_public_path__ + "static/img/payok.cdba8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payok.png
// module id = 6WhS
// module chunks = 1